import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=28a2bfb1&"
import script from "./Example.vue?vue&type=script&lang=js&"
export * from "./Example.vue?vue&type=script&lang=js&"
import style0 from "./Example.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports